import { IonButton } from '@ionic/react';
import { GrapeButton } from '../GrapeButton';
import { Hideable } from '../../hideable';
import React from 'react';
import FontAwesome from 'react-fontawesome';
const imageContainerStyle = {
    backgroundColor: 'white',
    borderRadius: '4px',
    border: '1px solid rgba(0,0,0,0.1)',
    margin: '0.5rem',
};
export function DropAreaImage(props) {
    // CONSTANT DECLARATION
    const { children, imageUrl, multiple = false, onImageDelete } = props;
    return (React.createElement("div", { key: imageUrl, style: imageContainerStyle },
        React.createElement("div", null,
            React.createElement("img", { src: imageUrl, alt: "", style: { maxHeight: '60px', width: 'auto' } })),
        React.createElement("div", null,
            React.createElement(Hideable, { hide: !multiple },
                React.createElement(GrapeButton, { type: "button" },
                    React.createElement(FontAwesome, { name: "star" }))),
            React.createElement(IonButton, { type: "button", onClick: () => onImageDelete && onImageDelete(imageUrl) }, children !== null && children !== void 0 ? children : 'Delete'))));
}
//# sourceMappingURL=dropAreaImage.js.map